export default "__VITE_ASSET__CCWlYsNS__"